import { XAxisOptions } from "highcharts";

export function addXAxisPipe(categories?: string[] | null, axis?: XAxisOptions) {
  return (options: Highcharts.Options): Highcharts.Options => {
    const hasXAxis = Boolean(options.xAxis);
    let xAxis: XAxisOptions | XAxisOptions[];
    const newAxis: XAxisOptions = categories ? { categories, ...axis } : { ...axis };
    if (hasXAxis) {
      xAxis = [] as XAxisOptions[];
      if (Array.isArray(options.xAxis!)) {
        xAxis = xAxis.concat(options.xAxis);
      } else {
        xAxis = [options.xAxis!];
      }
      xAxis.push(newAxis);
    } else {
      xAxis = newAxis;
    }

    return {
      ...options,
      xAxis,
    };
  };
}
